/* SK Legal Content - Solo scroll suave y TOC activo v6 */
/* NO crea links - el TOC viene del Liquid */
(function () {
  'use strict';

  function init() {
    var tocNav = document.querySelector('.sk-legal__toc-nav');
    if (!tocNav) return;

    var links = tocNav.querySelectorAll('a[href^="#legal-"]');
    if (!links.length) return;

    /* Borrar cualquier link que NO sea del Liquid (href sin #legal-) */
    tocNav.querySelectorAll('a:not([href^="#legal-"])').forEach(function (l) {
      l.remove();
    });

    var activeClass = 'sk-legal__toc-link--active';
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tocNav.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      e.preventDefault();

      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      target.scrollIntoView({
        behavior: prefersReduced ? 'auto' : 'smooth',
        block: 'start'
      });

      links.forEach(function (l) { l.classList.remove(activeClass); });
      link.classList.add(activeClass);
    });

    var headings = [];
    links.forEach(function (l) {
      var id = l.getAttribute('href').replace('#', '');
      var h = document.getElementById(id);
      if (h) headings.push(h);
    });

    if ('IntersectionObserver' in window && headings.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              links.forEach(function (l) {
                if (l.getAttribute('href') === '#' + entry.target.id) {
                  l.classList.add(activeClass);
                } else {
                  l.classList.remove(activeClass);
                }
              });
            }
          });
        },
        { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
      );
      headings.forEach(function (h) { observer.observe(h); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
